import clsx from "clsx";

import type { SelectV3Option } from "../SelectV3";
import type { CreateLinkTranslations, RebateProgramOption } from "./types";

import { CheckPaddedIcon } from "../Icons";
import { SelectV3 } from "../SelectV3";
import { Typo } from "../Typo";

type RebateProgramSelectProps = {
  options: RebateProgramOption[];
  value: RebateProgramOption | null;
  onChange: (option: SelectV3Option) => void;
  translations: CreateLinkTranslations;
  className?: string;
};

const RebateProgramValue = ({ option }: { option: SelectV3Option }) => {
  const prog = option as RebateProgramOption;
  return (
    <div className="flex flex-col text-left">
      <Typo element="span" type="bodySM" textColor="text-text-primary">
        HOID {prog.hoid} · {prog.currency}
      </Typo>
    </div>
  );
};

const RebateProgramOptionCell = ({
  option,
  isSelected,
}: {
  option: SelectV3Option;
  isSelected: boolean;
}) => {
  const prog = option as RebateProgramOption;
  return (
    <>
      <div className="flex flex-col text-left">
        <Typo
          element="span"
          type="labelSM"
          textColor={isSelected ? "text-text-selected" : "text-text-primary"}
        >
          HOID {prog.hoid} · {prog.currency}
        </Typo>
        <Typo
          element="span"
          type="bodyXS"
          textColor={isSelected ? "text-text-selected" : "text-text-secondary"}
        >
          Rebate account: {prog.rebateAccount}
        </Typo>
      </div>
      <CheckPaddedIcon
        className={clsx(
          "h-6 w-6 [&_path]:stroke-stroke-selected",
          isSelected ? "visible" : "invisible",
        )}
      />
    </>
  );
};

export const RebateProgramSelect = ({
  options,
  value,
  onChange,
  translations,
  className,
}: RebateProgramSelectProps) => {
  return (
    <SelectV3
      id="rebate-program-select"
      label={translations.rebateProgramLabel}
      className={clsx("[&_label_p:first-child]:!text-[0.875rem]", className)}
      subLabel={translations.rebateProgramSubLabel}
      placeholder={translations.rebateProgramPlaceholder}
      options={options}
      value={value}
      onChange={onChange}
      enableSearch={false}
      modal
      renderValue={(option) => <RebateProgramValue option={option} />}
      renderOptionCell={(params) => <RebateProgramOptionCell {...params} />}
      dropdownListClassName="p-4"
    />
  );
};
